import { STOCK_TAKING_CAR_MANAGEMENT_DETAILS_BEGIN } from "../constants"

export function getTakingCarDetails({ takingCarId }){
    return (dispatch) =>{
        dispatch({
            type: STOCK_TAKING_CAR_MANAGEMENT_DETAILS_BEGIN,
            data: { takingCarId }
        })
    }
}